import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AppProvider } from './context/AppContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import UsagePage from './pages/UsagePage';
import NotificationsPage from './pages/NotificationsPage';
import PromosPage from './pages/PromosPage';
import AppsPage from './pages/AppsPage';
import AILearningPage from './pages/AILearningPage';

function App() {
  return (
    <AppProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/usage" element={<UsagePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/promos" element={<PromosPage />} />
          <Route path="/apps" element={<AppsPage />} />
          <Route path="/ai-learning" element={<AILearningPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </HashRouter>
      <Toaster
        position="top-center"
        containerStyle={{ top: 72 }}
        toastOptions={{
          duration: 5000,
          style: {
            background: 'rgba(15, 23, 42, 0.96)',
            color: '#f1f5f9',
            border: '1px solid rgba(148, 163, 184, 0.25)',
            fontSize: '13px',
            maxWidth: 'min(420px, 92vw)',
          },
          success: {
            duration: 5500,
            iconTheme: { primary: '#5eead4', secondary: '#0f172a' },
          },
          error: {
            duration: 8000,
            iconTheme: { primary: '#fb7185', secondary: '#0f172a' },
          },
        }}
      />
    </AppProvider>
  );
}

export default App;
